import {
	createTheme
} from "@mui/system";

export const SIDE_GUTTER = '18px';

const customComponentsTheme = {
	AppFooter: {
		height: '56px',
		width: '100%',
		position: 'fixed',
		bottom: '0px'
	},
}

export const baseTheme = createTheme({
		components: {
			MuiContainer: {
				styleOverrides: {
					root: {
						paddingLeft: SIDE_GUTTER,
						paddingRight: SIDE_GUTTER,
						height: '100%',
						width: '100%',
						overflowX: 'hidden'
					}
				}
			},
			MuiToolbar: {
				styleOverrides: {
					gutters: {
						paddingLeft: SIDE_GUTTER,
						paddingRight: SIDE_GUTTER,
					},
					root: {
						// height: '56px',
						// minHeight: '56px !important',
						height: '66px',
						minHeight: '66px !important',
					}
				}
			},
			MuiInputLabel: {
				styleOverrides: {
					root: ({
						theme
					}) => ({
						color: theme.palette.primary.dark,
						marginTop: theme.spacing(0),
					})
				}
			},
			MuiInputBase: {
				styleOverrides: {
					root: {
						marginTop: '0px !important',
						'&::before': {
							borderBottom: 'none !important'
						},
						'.MuiNativeSelect-iconStandard': { // Chevron icon for Select
							top: "calc(50% - .1rem)"
						},
						'&.MuiInputBase-multiline': {
							padding: 0
						}
					},
					input: ({ theme }) => ({
						borderRadius: 4,
						position: 'relative',
						backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : '#2b2b2b',
						border: `1px solid ${theme.palette.primary.main}`,
						fontSize: 16,
						// width: 'auto',
						padding: '6px 12px',
						marginTop: '16px',
						transition: theme.transitions.create([
							'border-color',
							'background-color',
							'box-shadow',
						]),
						// Use the system font instead of the default Roboto font.
						fontFamily: [
							'-apple-system',
							'BlinkMacSystemFont',
							'"Segoe UI"',
							'Roboto',
							'Arial',
							'sans-serif',
							'"Apple Color Emoji"',
							'"Segoe UI Emoji"',
							'"Segoe UI Symbol"',
						].join(','),
						'&:focus': {
							borderColor: theme.palette.primary.main,
						},
						'&.MuiInputBase-inputMultiline': {
							border: 'none',
							margin: 0,
							padding: '6px'
						},
						'&.MuiNativeSelect-select': { // Select input
							'&:focus': {
								borderColor: theme.palette.primary.main,
								backgroundColor: '#ffffff'
							}
						}
					})
				}
			},
			MuiInputAdornment: {
				styleOverrides: {
					root: {
						position: 'absolute',
						right: '6px',
						top: '18px',
						height: '100%'
					}
				}
			}
		}
	},
	customComponentsTheme);